module.exports = __webpack_public_path__ + "static/media/reina.1ec9e3da.png";